<template>
  <div class="card large">
    <header class="has-text-centered card-title">
      <!-- <a :href="item.link" target="_blank" rel="noopener noreferrer nofollow">
        <h3 class="is-uppercase title is-size-5">{{item.title}}</h3>
      </a>-->
      <router-link :to="{name: 'itemdetail', params: {slug: item.slug}}">
        <h3 class="is-uppercase title is-size-5">
          <text-highlight :queries="highlight || ''" :caseSensitive="false">{{item.title}}</text-highlight>
        </h3>
      </router-link>
    </header>
    <section>
      <div class="card-image">
        <figure class="image">
          <a :href="item.link" target="_blank" rel="noopener noreferrer nofollow">
            <picture>
              <source type="image/webp" :srcset="item.image_src_webp" />
              <img
                :src="item.image_src_jpg"
                :alt="'zdjęcie ' + item.title"
                style="max-height:25rem;width:auto;margin-left: auto;margin-right: auto;"
              />
            </picture>
          </a>
        </figure>
      </div>
      <div class="card-content">
        <div class="content has-text-justified">
          <text-highlight :queries="highlight || ''" :caseSensitive="false">{{ item.description }}</text-highlight>
        </div>
        <tags :tags="item.tags" :highlight="highlight"></tags>
      </div>
    </section>
    <section class="price-section">
      <nav class="level">
        <div class="level-left">
          <div class="level-item">
            <a :href="item.link" target="_blank" rel="noopener noreferrer nofollow">
              <p class="title has-test-centered">{{item.price}} zł</p>
            </a>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <a
              :href="item.link"
              target="_blank"
              rel="noopener noreferrer nofollow"
              class="button is-danger is-uppercase has-text-weight-bold"
            >Obczaj to</a>
          </div>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>
import Tags from "./Tags";

export default {
  name: "Card",
  props: ["item", "highlight"],
  components: { Tags },
};
</script>

<style>
.price-section {
  padding-top: 0rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-bottom: 1.5rem;
  margin-top: auto;
}
.card-title {
  padding: 1rem;
}
</style>
